import Vue from 'vue'
import Vuex from 'vuex'
import user from "@/store/user";

Vue.use(Vuex)

const store =  new Vuex.Store({
  modules: {
    user
  },
  getters: {
    isShowHeaderBg: state => state.user.isShowHeaderBg,
    languageType: state => state.user.languageType,
    isPermanentShowHeaderBg: state => state.user.isPermanentShowHeaderBg,
  },
})

export default store
